if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.hero-slide'));
      this.track = this.querySelector('.hero-slideshow__track');
      this.dots = Array.from(this.querySelectorAll('.hero-dot'));
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.playPauseBtn = this.querySelector('[data-action="toggle-autoplay"]');
      this.counterCurrent = this.querySelector('.hero-counter__current');
      
      this.currentIndex = 0;
      this.isFade = this.classList.contains('hero-slideshow--fade');
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed || '5000', 10);
      this.timer = null;

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => this.goTo(idx));
      });

      if (this.autoplay) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      this.setupTouch();
      this.setupShopifyEvents();
      this.goTo(0);
    }

    setupShopifyEvents() {
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const slide = e.target.closest('.hero-slide');
        if (slide) {
          const index = this.slides.indexOf(slide);
          if (index !== -1) {
            this.stopAutoplay();
            this.goTo(index);
          }
        }
      });

      document.addEventListener('shopify:block:deselect', (e) => {
        if (!this.contains(e.target)) return;
        if (this.autoplay) this.startAutoplay();
      });

      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.contains(this) || e.target === this) {
          this.slides = Array.from(this.querySelectorAll('.hero-slide'));
          this.dots = Array.from(this.querySelectorAll('.hero-dot'));
          this.goTo(0);
        }
      });
    }

    goTo(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.currentIndex = index;

      if (this.isFade) {
        this.slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.add('is-active');
            this.playVideo(slide);
          } else {
            slide.classList.remove('is-active');
            this.pauseVideo(slide);
          }
        });
      } else if (this.track) {
        this.track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
        this.slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.add('is-active');
            this.playVideo(slide);
          } else {
            slide.classList.remove('is-active');
            this.pauseVideo(slide);
          }
        });
      }

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      if (this.counterCurrent) {
        this.counterCurrent.textContent = index + 1;
      }
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    startAutoplay() {
      if (this.timer || this.slides.length <= 1) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    playVideo(slide) {
      const video = slide.querySelector('video');
      if (video) {
        video.play().catch(() => {});
      }
    }

    pauseVideo(slide) {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
      }
    }

    setupTouch() {
      let startX = 0;
      let dist = 0;

      this.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        this.stopAutoplay();
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        dist = e.changedTouches[0].clientX - startX;
        if (Math.abs(dist) > 50) {
          if (dist < 0) this.next();
          else this.prev();
        }
        if (this.autoplay) this.startAutoplay();
      }, { passive: true });
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
}
